import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import styles from "../components/Hero.module.css";

const CustomBreadcrumb = (props) => {
  const formatTitle = (str) => {
    let toUpperCase = str.charAt(0).toUpperCase() + str.slice(1);

    return toUpperCase.length > 40
      ? toUpperCase.slice(0, 40) + "..."
      : toUpperCase;
  };
  return (
    <Breadcrumb
      px={["2", "20"]}
      py="4"
      // mt={["135px", "155px"]}
      className={styles.Breadcrumb}
      bg={props.bg ? props.bg : "#eee"}
      position={props.fixed ? "fixed" : "fixed"}
      w="100%"
      zIndex="300"
    >
      <BreadcrumbItem>
        <BreadcrumbLink as={Link} to="/" fontSize={["14px", "16px"]}>
          Home
        </BreadcrumbLink>
      </BreadcrumbItem>
      {props.links.map((link, idx) => (
        <BreadcrumbItem
          isCurrentPage={idx === props.links.length - 1}
          key={idx}
        >
          <BreadcrumbLink
            as={Link}
            to={idx !== props.links.length - 1 && `${link.link}`}
            fontSize={["14px", "16px"]}
          >
            {formatTitle(link.title)}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};

export default CustomBreadcrumb;
